'use client';
import { useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';

import Error from '@/shared/ui/svgs/500';

const PcError = () => {
  const t = useTranslations('500');

  const router = useRouter();

  return (
    <section className="mx-auto w-max h-screen flex flex-col justify-center">
      <div className="w-full flex justify-center">
        <Error />
      </div>
      <p className="text-[42px] font-semibold leading-[52px] text-center mt-[48px] mb-[8px]">
        {t('title')}
      </p>
      <p className="text[18px] leading-[28px] font-normal text-center text-[#434343] mb-[40px]">
        {t('description')}
      </p>
      <button
        className="bg-[#004EFF] w-max py-[16px] px-[24px] rounded-[40px] text-white text-[18px] leading-[28px] flex mx-auto"
        onClick={router.back}
      >
        {t('button')}
      </button>
    </section>
  );
};

export default PcError;
